import getIn from 'transmute/getIn';
export const getShowQuickReplyOutsideChatGate = state => {
  return getIn(['widgetData', 'data', 'gates'], state).get('Conversations:QuickRepliesOutsideChat');
};